import { Button } from "@repo/ui/button";
import { Bot, Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import type { SnapshotAuthenticityCheck } from "@/lib/api";
import { JevCheckBadge } from "./JevCheckBadge";

/** Results-table cell: the latest Jev badge plus a "Check with Jev" action for operators and admins. */
export function JevCheckCell({
  check,
  isChecking,
  onCheck,
}: {
  check: SnapshotAuthenticityCheck | undefined;
  isChecking: boolean;
  onCheck: () => void;
}) {
  const { canManageJobs } = useAuth();
  return (
    <div className="flex min-w-40 flex-col items-start gap-1">
      {isChecking ? (
        <span className="inline-flex items-center gap-1 text-xs text-muted-foreground">
          <Loader2 className="h-3 w-3 animate-spin" />
          Checking…
        </span>
      ) : (
        <JevCheckBadge check={check} />
      )}
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="h-7 px-2 text-xs"
        disabled={!canManageJobs || isChecking}
        title={canManageJobs ? undefined : "Operator or admin access required"}
        onClick={onCheck}
      >
        <Bot className="mr-1 h-3.5 w-3.5" />
        Check with Jev
      </Button>
    </div>
  );
}
